<script setup lang="ts">
import LogoimgNeg from '@/assets/images/logos/logo-neg.png';
import Logoimg from '@/assets/images/logos/logo-pos.png';
import { RouterLink } from 'vue-router';
const props = defineProps({
  showNeg: {
    type: Boolean,
    default: false,
  },    
  maxHeight: {
    type: [String, Number],
    default: '50',
  },
});
</script>
<template>
    <div class="logo">
        <RouterLink to="/">
            <v-img :src="props.showNeg ? LogoimgNeg : Logoimg" alt="home" :max-height="props.maxHeight" />
        </RouterLink>
    </div>
</template>